/* Position the native account sheet below the visible header without touching auth. */
if (!customElements.get('dope-account-entry')) {
  customElements.define('dope-account-entry', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      this.accountOpen = false;
      this.accountEscape = false;
      const position = () => {
        const header = document.querySelector('.header');
        const bottom = header?.getBoundingClientRect().bottom ?? 0;
        // Leave room for Shopify's internally scrollable sheet on short screens.
        const top = Math.max(12, Math.min(bottom + 12, window.innerHeight - 240));
        this.style.setProperty('--dope-account-top', `${top}px`);
      };
      this.addEventListener('pointerdown', position, { signal: this.controller.signal });
      this.addEventListener('focusin', position, { signal: this.controller.signal });
      // Shopify closes its sheet before the theme's document keyup listener runs.
      // Keep that same Escape press from also dismissing the navigation underneath.
      this.addEventListener('keydown', event => {
        this.accountEscape = event.code === 'Escape' && this.accountOpen;
      }, { capture: true, signal: this.controller.signal });
      this.addEventListener('keyup', event => {
        if (event.code !== 'Escape' || !this.accountEscape) return;
        this.accountEscape = false;
        event.stopPropagation();
      }, { signal: this.controller.signal });
      const bindAccount = () => {
        const account = this.querySelector('shopify-account');
        account?.addEventListener('open', () => {
          this.accountOpen = true;
          position();
        }, { signal: this.controller.signal });
        account?.addEventListener('close', () => {
          this.accountOpen = false;
        }, { signal: this.controller.signal });
      };
      const mountAccount = () => {
        const template = this.querySelector('template[data-account-lazy]');
        if (!template) return;
        // Keep a focused fallback link stable. It remains a working sign-in link.
        const fallback = this.querySelector('.dope-account-entry__fallback');
        if (fallback?.contains(document.activeElement)) return;
        template.replaceWith(template.content.cloneNode(true));
        this.observer?.disconnect();
        bindAccount();
      };
      if (this.querySelector('template[data-account-lazy]')) {
        // Hidden desktop headers, closed drawers and offscreen footer entries
        // must not start Shopify account/pre-auth work during the initial load.
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) mountAccount();
          });
          this.observer.observe(this);
          this.addEventListener('focusout', mountAccount, { signal: this.controller.signal });
        }
      } else {
        bindAccount();
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
